module.exports = __webpack_public_path__ + "img/moto.03adde52.png";